const uySeguroDeSaludBpsOptions = [
  {
    value: "SS15, 4%",
    description: "SS15, 4%",
  },
  {
    value: "Sin hijos ni cónyuge, 5%",
    description: "Sin hijos ni cónyuge, 5%",
  },
  {
    value: "SS1, 6%",
    description: "SS1, 6%",
  },
  {
    value: "SS17, 6%",
    description: "SS17, 6%",
  },
  {
    value: "SS16, 8%",
    description: "SS16, 8%",
  },
];

export { uySeguroDeSaludBpsOptions };
